import { EstimateBalance, EstimateData, LetterSnapshot } from '@mmx/shared'

export type BalanceSendChannel = 'email' | 'sms'

/** Everything the summary surface renders. Bundled so the parent passes one cohesive view-model instead of N parallel inputs. */
export interface BalanceSummaryData {
  balance: EstimateBalance | null
  estimate: EstimateData | null
  latestSnapshot: LetterSnapshot | null
}

/** Which actions the parent will honor. All-false means the menu shows nothing. */
export interface BalanceSummaryCapabilities {
  canSave: boolean
  canFinalize: boolean
  canRevert: boolean
  canDelete: boolean
  canSend: boolean
  /** Per-channel gates — false when the patient lacks a usable contact (email bounced, no textable number, etc.). */
  canSendEmail: boolean
  canSendSms: boolean
  /** PDF is email-only — kept distinct from canSendEmail so a future change to email gating doesn't silently retarget this too. */
  canSendDocument: boolean
  canViewHistory: boolean
  canPrintLetter: boolean
}

// Frozen so a misbehaving consumer mutating a default-bound @Input value
// can't corrupt the shared default for every other instance.
export const EMPTY_BALANCE_SUMMARY_DATA: Readonly<BalanceSummaryData> = Object.freeze({
  balance: null,
  estimate: null,
  latestSnapshot: null,
})

export const NO_BALANCE_SUMMARY_CAPABILITIES: Readonly<BalanceSummaryCapabilities> = Object.freeze({
  canSave: false,
  canFinalize: false,
  canRevert: false,
  canDelete: false,
  canSend: false,
  canSendEmail: false,
  canSendSms: false,
  canSendDocument: false,
  canViewHistory: false,
  canPrintLetter: false,
})
